import React from 'react';
import { motion } from 'framer-motion';
import { MessageSquare, Clock, Send, CheckCircle } from 'lucide-react';

interface StatusButtonProps {
  requestStatus: 'accepted' | 'declined' | 'pending' | null;
  isRequestDisabled: boolean;
  handleGiveFeedback: () => void;
  handleRequestIntroduction: () => void;
  onRequestIntroduction?: boolean;
}

const StatusButton: React.FC<StatusButtonProps> = ({ 
  requestStatus,
  isRequestDisabled,
  handleGiveFeedback,
  handleRequestIntroduction,
  onRequestIntroduction
}) => {
  if (requestStatus === 'accepted') {
    return (
      <motion.button
        whileHover={{ scale: 1.02 }}
        whileTap={{ scale: 0.98 }}
        onClick={handleGiveFeedback}
        className="w-full px-6 py-3 bg-gradient-to-r from-lime-green to-soft-teal text-white font-semibold rounded-xl hover:shadow-lg transition-all duration-300 flex items-center justify-center"
      >
        <MessageSquare className="w-4 h-4 mr-2" />
        Give Feedback
      </motion.button>
    );
  }

  if (requestStatus === 'declined') {
    return (
      <div className="w-full px-6 py-3 bg-red-100 text-red-600 font-semibold rounded-xl flex items-center justify-center cursor-not-allowed">
        <span>Request Declined</span>
      </div>
    );
  }

  if (requestStatus === 'pending') {
    return (
      <div className="w-full px-6 py-3 bg-yellow-100 text-yellow-700 font-semibold rounded-xl flex items-center justify-center cursor-not-allowed">
        <Clock className="w-4 h-4 mr-2" />
        Request Pending
      </div>
    );
  }

  if (isRequestDisabled) {
    return (
      <div className="w-full px-6 py-3 bg-gray-100 text-gray-600 font-semibold rounded-xl flex items-center justify-center cursor-not-allowed">
        <Send className="w-4 h-4 mr-2" />
        Request Sent
      </div>
    );
  }

  return (
    <motion.button
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
      onClick={handleRequestIntroduction}
      disabled={!onRequestIntroduction}
      className="w-full px-6 py-3 bg-gradient-primary text-white font-semibold rounded-xl hover:shadow-lg transition-all duration-300 flex items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed"
    >
      <CheckCircle className="w-4 h-4 mr-2" />
      Request Introduction
    </motion.button>
  );
};

export default StatusButton;
